import React from "react";

export default function ColorFrame20({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          d="M38.1305 180.583C7 115.92 7 11.04 7 11.04C7 11.04 38.8717 20.1086 66.2962 20.1086C93.7207 20.1086 138.193 0 138.193 0V276C138.193 276 69.261 245.246 38.1305 180.583Z"
          fill="url(#paint0_linear_2087_157478)"
        />
        <path
          d="M238.255 180.583C269.386 115.92 269.386 11.04 269.386 11.04C269.386 11.04 237.514 20.1086 210.09 20.1086C182.665 20.1086 138.193 0 138.193 0V276C138.193 276 207.125 245.246 238.255 180.583Z"
          fill="#BDD0FB"
        />
        <circle
          cx="138.754"
          cy="128.5"
          r="88.5"
          fill="white"
          stroke="#FFC444"
          strokeWidth="10"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2087_157478"
            x1="-65.6379"
            y1="288.617"
            x2="302.149"
            y2="-15.2414"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.268611" stopColor="#7A6FF7" />
            <stop offset="1" stopColor="#E5F0FF" />
          </linearGradient>
        </defs>
        {children}
      </g>
    </svg>
  );
}
